import { DOMAIN_DETAIL } from "../Types/types";

const intialState = {
  menuList: [
    {
      name: "Jobs",
      path: "/jobs",
      icon: "bag-icon.svg",
      activeIcon: "bag-icon-pink.svg",
      showInDesktop: true,
      showInMobile: true,
    },
    {
      name: "Candidates",
      path: "/candidates-management",
      icon: "personality-wight.svg",
      activeIcon: "personality-pink.svg",
      showInDesktop: true,
      showInMobile: true,
    },
    {
      name: "Assessments",
      path: "/assessments",
      icon: "shield-trust.svg",
      activeIcon: "shield-trust-pink.svg",
      showInDesktop: true,
      showInMobile: true,
      showSubMenuInMobile: false,
      subMenu: [
        { name: "My Assessments", path: "/assessments" },
        { name: "Test Library", path: "/gappeo-tests" },
        { name: "My Tests", path: "/my-tests" },
        { name: "My Questions", path: "/my-questions" },

      ]
    },
    {
      name: "Messenger",
      path: "/messenger",
      icon: "messenger-icon.svg",
      activeIcon: "send.svg",
      showInDesktop: true,
      showInMobile: false,
    },
    {
      name: "Onboarding",
      icon: "user-plus-icon.svg",
      showInDesktop: true,
      showInMobile: false,
      showSubMenuInMobile: false,
      subMenu: [
        { name: "Flows", path: "/onboarding/flows" },
        { name: "Active Onboarding", path: "/onboarding/active" },
        { name: "Forms", path: "/onboarding/forms" },
        { name: "Document Center", path: "/onboarding/documents" },
        // { name: "Checklists", path: "/onboarding/checklists" },
      ]
    },
    {
      name: "Insights ",
      icon: "analytics.svg",
      showInDesktop: true,
      showInMobile: false,
      subMenu: [
        { name: "Dashboard", path: "/dashboard" },
        { name: "Assessments", path: "/reports" },
        { name: "Voice interview", path: "/voice-interviews-report" },
        { name: "Video interview", path: "/video-interviews-report" },
      ]
    },
    {
      name: "Settings",
      icon: "settings-icon-white.svg",
      showInDesktop: true,
      showInMobile: false,
      subMenu: [
        { name: "Company Profile", path: "/profile" },
        { name: "Companies", path: "/client-companies" },
        { name: "Teams", path: "/teams" },
        { name: "Users", path: "/team-members" },
        { name: "Roles", path: "/company-roles" },
        { name: "Integration", path: "/keys" },
        { name: "Usage and Plan", path: "/plan" },
      ]
    },
  ],
  adminMenuList: [
    {
      name: "Assessments",
      icon: "shield-trust.svg",
      subMenu: [
        { name: "My Questions", path: "/my-questions" }
      ]
    },
    {
      name: "Users",
      path: "/users",
      icon: "users.svg",
    }
  ],
};

export default function layoutReducer(state = intialState, action) {
  let stateCopy = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case DOMAIN_DETAIL:
      stateCopy.domainDetails = action.payload;
      localStorage.setItem("domainDetails", JSON.stringify(action.payload));
      return stateCopy;
    default:
      return stateCopy;
  }
}
